import './App.css';
import Routess from './routes';

const GoldShineDefs = () => (
  <svg
    width="0"
    height="0"
    style={{ position: 'absolute', width: 0, height: 0 }}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="gold-shine-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#BF953F" />
        <stop offset="25%" stopColor="#FCF6BA" />
        <stop offset="50%" stopColor="#B38728" />
        <stop offset="75%" stopColor="#FBF5B7" />
        <stop offset="100%" stopColor="#AA771C" />
      </linearGradient>
    </defs>
  </svg>
);

function App() {
  return (
    <div className="App">
      <GoldShineDefs />
      <Routess />
    </div>
  );
}

export default App;
